module.exports = {
  "zones": {
    "Asia/Barnaul": ["z", {
      "wallclock": 1459044000000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": 1459022400000,
      "save": 0
    }, {
      "wallclock": 1414288800000,
      "format": "+06",
      "abbrev": "+06",
      "offset": 21600000,
      "posix": 1414263600000,
      "save": 0
    }, {
      "wallclock": 1301191200000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": 1301169600000,
      "save": 0
    }, {
      "wallclock": 801619200000,
      "format": "+06/+07",
      "abbrev": "+07",
      "offset": 21600000,
      "posix": 801590400000,
      "save": 3600000,
      "rules": "Russia"
    }, {
      "wallclock": 695786400000,
      "format": "+07/+08",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": 695764800000,
      "save": 0,
      "rules": "Russia"
    }, {
      "wallclock": 670384800000,
      "format": "+06/+07",
      "abbrev": "+07",
      "offset": 21600000,
      "posix": 670359600000,
      "save": 3600000,
      "rules": "Russia"
    }, {
      "wallclock": -1247529600000,
      "format": "+07/+08",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": -1247551200000,
      "save": 0,
      "rules": "Russia"
    }, {
      "wallclock": -1579824000000,
      "format": "+06",
      "abbrev": "+06",
      "offset": 21600000,
      "posix": -1579844100000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 20100000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Russia": [{
      "from": 1985,
      "to": 2010,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2010,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1984,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1981,
      "to": 1983,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 1,
      "day": [7, 14],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "MSD",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 2,
      "day": [7, 20],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "+05",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 8,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "MSD",
      "saved": 7200000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 4,
      "day": [7, 31],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "MDST",
      "saved": 3600000
    }, {
      "from": 1919,
      "to": 1919,
      "month": 6,
      "day": [7, 1],
      "time": 0,
      "clock": "posix",
      "save": 60,
      "letter": "MSD",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 7,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "MSK",
      "saved": 3600000
    }, {
      "from": 1918,
      "to": 1918,
      "month": 4,
      "day": [7, 31],
      "time": 1320,
      "clock": "wallclock",
      "save": 120,
      "letter": "MDST",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 8,
      "day": [7, 16],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "MST",
      "saved": 7200000
    }, {
      "from": 1917,
      "to": 1917,
      "month": 6,
      "day": [7, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "MST",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 11,
      "day": [7, 28],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "MMT",
      "saved": 3600000
    }]
  }
};